import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'redux/schemas';
import { NLecturePage } from 'redux/schemas/models/lecture-page';
import { MyAccount } from 'redux/schemas/models/my-account';

import { getCurrentUser } from 'redux/selectors/users';
import { getCurrentInstitution } from 'redux/selectors/institutions';

import { updateRecentlyUsedColors } from 'redux/actions/users';

export const COLOR_LIST_LIMIT = 14;

interface UserColorsParams {
  currentLecture: NLecturePage;
}

/**
 * handles common logic for manipulating recently used colors and institution
 * brand colors, etc.
 */
/* @ngInject */
export default function useUserColors(params: UserColorsParams) {
  const dispatch = useDispatch();
  const currentUser = useSelector<RootState, MyAccount>(getCurrentUser);
  const currentInstitution = useSelector(getCurrentInstitution);
  const mainColorsObject = useSelector((state) => state.models.institutions[state.app.currentInstitutionId].orgColors.mainColors);
  const defaultColorPalette = Object.values(mainColorsObject);
  const { recentlyUsedColors } = currentUser;

  // TODO: I think we can just get the current course data here to avoid passing down currentLecture
  // create an array of brand color and filter nullish values
  const brandColors: string[] = [
    currentInstitution?.brandColor,
    (params.currentLecture as any)?.course?.headerColor,
  ].filter(Boolean);

  function updateRecentlyUsedColorsIfNeeded(color: string, preserveOrder?: boolean) {
    // if the colors is not in the predefined palette and brand colors
    if (!defaultColorPalette.includes(color) && !brandColors.includes(color)) {
      /** Avoids resaving & reordering the palette if the color is already present */
      if (preserveOrder && recentlyUsedColors.indexOf(color) !== -1) {
        return;
      }

      const newColorList = [
        color,
        // remove existing occurrences of the color
        ...recentlyUsedColors.filter((currentColor) => currentColor.toLowerCase() !== color.toLowerCase()),
      ].slice(0, COLOR_LIST_LIMIT);

      dispatch(updateRecentlyUsedColors(newColorList));
    }
  }

  return {
    updateRecentlyUsedColorsIfNeeded,
    brandColors,
    recentlyUsedColors,
  };
}
